const getSearchInputHeight = () => 48

export default getSearchInputHeight
